Vue.prototype.__ = window.__;
Vue.prototype.frappe = window.frappe;